import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultHistoryProgress } from '@/types/history/history-progress';
import type { IHistorySummaryModel, IHistorySummarySubmitResult } from '@/types/history/history-summary';

const HISTORY_SUMMARY_ENDPOINT = '/api/register/history-summary';

const defaultHistorySummaryModel: IHistorySummaryModel = {
    ...defaultHistoryProgress,
    currentRegistrationStep: DashRegistrationStep.HistorySummary,
};

export const useHistorySummary = (registrationId: number, editKey: string) => {
    const url = `${HISTORY_SUMMARY_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultHistorySummaryModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<void, DashRegistrationStep, IHistorySummarySubmitResult>(
        url,
        () => ({}),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
